import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { TypesUtilsService } from 'src/app/core/_base/crud';
import { AcDetailTransaction } from 'src/app/core/asset_class/_models/asset-class-detail.model';

@Component({
  selector: 'kt-inspection-transaction-history',
  templateUrl: './inspection-transaction-history.component.html',
  styleUrls: ['./inspection-transaction-history.component.scss']
})
export class InspectionTransactionHistoryComponent implements OnInit {
  @Input() currency: string;
  @Input() transactionsData: AcDetailTransaction[];
  @Input() commentData: string;
  transferTypes = [
    { id: 1, name: 'Sale' },
    { id: 2, name: 'Rent' },
  ]
  displayedColumns = ['transfer_type', 'value', 'date', 'actions'];
  @ViewChild('table') table: MatTable<UntypedFormGroup>;
  form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private typesUtilsService: TypesUtilsService
  ) { }

  ngOnInit(): void {
    const rows = this.transactionsData && this.transactionsData.length > 0
      ? this.transactionsData.map(item => this._createRow(item))
      : [this._createRow()];
    this.form = this.formBuilder.group({
      transactions: this.formBuilder.array(rows),
      comment: [this.commentData],
    });
  }

  get transactions(): UntypedFormArray {
    return this.form.get('transactions') as UntypedFormArray;
  }

  addRow(index: number) {
    this.transactions.insert(index + 1, this._createRow());
    this.table.renderRows();
  }

  removeRow(index: number) {
    this.transactions.removeAt(index);
    this.table.renderRows();
  }

  clearDate(ctrl: AbstractControl) {
    ctrl.setValue(null);
    ctrl.updateValueAndValidity();
  }

  getData(): {
    transactions: AcDetailTransaction[],
    transaction_comment: string
  } {
    return {
      transactions: this.transactions.controls.map(row => ({
        transfer_type_id: row.get('transfer_type_id').value,
        value: toNumber(row.get('value').value),
        date: row.get('date').value
          ? this.typesUtilsService.getDateStringFromDate(new Date(row.get('date').value))
          : null,
      })),
      transaction_comment: this.form.controls.comment.value,
    };
  }

  private _createRow(item?: AcDetailTransaction): UntypedFormGroup {
    return this.formBuilder.group({
      transfer_type_id: [item ? item.transfer_type_id : null],
      value: [item ? item.value : null],
      date: [item ? item.date : null],
    });
  }
}

function toNumber(value: any): number {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const num = Number(value);
  return isNaN(num) ? null : num;
}
